module.exports = __webpack_public_path__ + "static/img/test-bg-3.4e3fd9d6.png";